(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 7286:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(4288);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8287);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3376);





function Footer(param) {
    let { links , locale  } = param;
    const { t  } = useTranslation();
    const lang = locale || "fr";
    return /*#__PURE__*/ _jsxs("div", {
        className: "footer",
        children: [
            /*#__PURE__*/ _jsxs("h2", {
                children: [
                    t("footer.title.1"),
                    /*#__PURE__*/ _jsx("br", {}),
                    " ",
                    t("footer.title.2"),
                    " ",
                    /*#__PURE__*/ _jsx("br", {}),
                    " ",
                    t("footer.title.3"),
                    " ",
                    /*#__PURE__*/ _jsx(FooterHeadingHand, {})
                ]
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "footer_links_page",
                children: links.map((l, i)=>/*#__PURE__*/ _jsx("a", {
                        href: l.href,
                        children: l.label
                    }, i))
            }),
            /*#__PURE__*/ _jsxs("ul", {
                className: "footer_company_info",
                children: [
                    /*#__PURE__*/ _jsxs("li", {
                        children: [
                            "Bene Bono\xae ",
                            new Date().getFullYear()
                        ]
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        href: lang !== "es" && "https://static.horsnormes.co/static/legal/20220224-BeneBono-Politique-De-Confidentialite.pdf",
                        target: "_blank",
                        rel: "noreferrer",
                        children: t("footer.privacynotice")
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        href: lang !== "es" ? "https://static.horsnormes.co/static/legal/20241001-CGV-BeneBono.pdf" : "https://static.horsnormes.co/static/legal/CGV-spain.pdf",
                        target: "_blank",
                        rel: "noreferrer",
                        children: t("footer.conditionsofuse")
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        href: "https://static.horsnormes.co/static/legal/20241001-BeneBono-MentionsLegales.pdf",
                        target: "_blank",
                        rel: "noreferrer",
                        children: t("footer.legal_mentions")
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        children: t("footer.cookies")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(LogoFooter, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "footer_socials",
                children: [
                    /*#__PURE__*/ _jsx("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.instagram.com/benebono.es/" : "https://www.instagram.com/benebono.fr/",
                        children: /*#__PURE__*/ _jsx(Instagram, {})
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.facebook.com/benebono.es/" : "https://www.facebook.com/benebono.fr/",
                        children: /*#__PURE__*/ _jsx(Facebook, {})
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.linkedin.com/company/benebono-fr" : "https://www.linkedin.com/company/benebono-fr",
                        children: /*#__PURE__*/ _jsx(Linkedin, {})
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "footer_benebono_info",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: t("footer.email")
                            }),
                            lang === "es" && /*#__PURE__*/ _jsx("p", {
                                children: t("footer.openhour")
                            }),
                            lang === "es" && /*#__PURE__*/ _jsx("p", {
                                children: t("footer.phonenumber")
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: t("footer.address")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: t("footer.certification")
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: t("footer.certification.code")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 4554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8287);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3376);






function Pagination(param) {
    let { pageCount , filters , link  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { page: pageIndex  } = router.query;
    const pageCountArray = [];
    for(let i = 0; i < pageCount; i++){
        pageCountArray.push(i + 1);
    }
    const firstPage = pageCountArray[0];
    const totalPages = pageCountArray[pageCountArray.length - 1];
    const currentPageIndex = Number(pageIndex);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pagination_container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "".concat(link, "?page=").concat(currentPageIndex - 1).concat(filters ? "&".concat(filters) : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_5__/* .ArrowLeft */ .Xd, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: t("button.pagination.previous")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                children: [
                    currentPageIndex > firstPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            style: parseInt(currentPageIndex) === firstPage ? {
                                backgroundColor: "#164230",
                                color: "#FFFFFF"
                            } : {
                                backgroundColor: "#f6faf7",
                                color: "#164230"
                            },
                            className: "pagination_link",
                            href: "".concat(link, "?page=").concat(firstPage).concat(filters ? "&".concat(filters) : ""),
                            children: firstPage
                        })
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            style: parseInt(currentPageIndex) ? {
                                backgroundColor: "#164230",
                                color: "#FFFFFF"
                            } : {
                                backgroundColor: "#f6faf7",
                                color: "#164230"
                            },
                            className: "pagination_link",
                            href: "".concat(link, "?page=").concat(currentPageIndex).concat(filters ? "&".concat(filters) : ""),
                            children: currentPageIndex
                        })
                    }),
                    totalPages >= 2 && currentPageIndex < totalPages && currentPageIndex + 1 !== totalPages ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        "aria-label": "current-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            style: parseInt(currentPageIndex) === pageIndex ? {
                                backgroundColor: "#164230",
                                color: "#FFFFFF"
                            } : {
                                backgroundColor: "#f6faf7",
                                color: "#164230"
                            },
                            className: "pagination_link",
                            href: "".concat(link, "?page=").concat(currentPageIndex + 1).concat(filters ? "&".concat(filters) : ""),
                            children: currentPageIndex + 1
                        })
                    }) : null,
                    totalPages >= 3 && currentPageIndex <= totalPages && currentPageIndex + 2 !== totalPages && currentPageIndex + 2 < totalPages && currentPageIndex + 1 !== totalPages && currentPageIndex + 2 < totalPages ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        "aria-label": "current-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            style: parseInt(currentPageIndex) === pageIndex ? {
                                backgroundColor: "#164230",
                                color: "#FFFFFF"
                            } : {
                                backgroundColor: "#f6faf7",
                                color: "#164230"
                            },
                            className: "pagination_link",
                            href: "".concat(link, "?page=").concat(currentPageIndex + 2).concat(filters ? "&".concat(filters) : ""),
                            children: currentPageIndex + 2
                        })
                    }) : null,
                    currentPageIndex !== totalPages ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        "aria-label": "total-pages",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            style: parseInt(currentPageIndex) === pageIndex ? {
                                backgroundColor: "#164230",
                                color: "#FFFFFF"
                            } : {
                                backgroundColor: "#f6faf7",
                                color: "#164230"
                            },
                            className: "pagination_link",
                            href: "".concat(link, "?page=").concat(totalPages).concat(filters ? "&".concat(filters) : ""),
                            children: totalPages
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "".concat(link, "?page=").concat(currentPageIndex + 1).concat(filters ? "&".concat(filters) : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: t("button.pagination.next")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_5__/* .ArrowRight */ .ol, {})
                ]
            })
        ]
    });
}


/***/ }),

/***/ 1216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RefreshedFooter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7421);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3376);



function RefreshedFooter(param) {
    let { links , locale  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const lang = locale || "fr";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "footer_title",
                children: t("footer.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "footer_socials",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer_socials__circle facebook",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noreferrer",
                            href: lang === "es" ? "https://www.facebook.com/benebono.es/" : "https://www.facebook.com/benebono.fr/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_2__/* .BenebonoFacebook */ .To, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer_socials__circle",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noreferrer",
                            href: lang === "es" ? "https://www.instagram.com/benebono.es/" : "https://www.instagram.com/benebono.fr/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_2__/* .BenebonoInstagram */ .yR, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer_socials__circle",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noreferrer",
                            href: lang === "es" ? "https://www.linkedin.com/company/benebono-fr" : "https://www.linkedin.com/company/benebono-fr",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_2__/* .BenebonoLinkedin */ .f8, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "footer_links",
                children: links.map((l, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: l.href,
                        children: l.label
                    }, i))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "footer_third_row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "footer_company_info",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                children: [
                                    "Bene Bono\xae ",
                                    new Date().getFullYear()
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: lang !== "es" && "https://static.horsnormes.co/static/legal/20220224-BeneBono-Politique-De-Confidentialite.pdf",
                                target: "_blank",
                                rel: "noreferrer",
                                children: t("footer.privacynotice")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: lang !== "es" ? "https://static.horsnormes.co/static/legal/20241001-CGV-BeneBono.pdf" : "https://static.horsnormes.co/static/legal/CGV-spain.pdf",
                                target: "_blank",
                                rel: "noreferrer",
                                children: t("footer.conditionsofuse")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://static.horsnormes.co/static/legal/20241001-BeneBono-MentionsLegales.pdf",
                                target: "_blank",
                                rel: "noreferrer",
                                children: t("footer.legal_mentions")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: t("footer.cookies")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer_logo",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_2__/* .LogoFooter */ .vP, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "footer_address",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "addresses",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.email")
                                    }),
                                    lang === "es" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.openhour")
                                    }),
                                    lang === "es" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.phonenumber")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.address")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "certification",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.certification")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.certification.code")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 4288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./assets/index.js + 29 modules
var assets = __webpack_require__(3376);
;// CONCATENATED MODULE: ./components/Posts/Posts.js




function Posts(param) {
    let { imageUrl , tags , title , author , date , description , slugUrl  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: "/blog/".concat(slugUrl),
        className: "article",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "article_picture",
                src: imageUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "article_info_container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: tags.map((t, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: t
                            }, i))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "article_title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "article_info",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: author
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: date
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: description
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/Pagination/Pagination.js
var Pagination = __webpack_require__(4554);
;// CONCATENATED MODULE: ./components/PostsRow/PostsRow.js




function PostsRow(param) {
    let { imageUrl , tags , title , author , date , description , slugUrl  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "posts_row_container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "post_row_info",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "tags",
                    children: tags
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "article_info",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: author
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: date
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/blog/".concat(slugUrl),
                    className: "posts_link",
                    children: "Lire l'article"
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Nav/Nav.js
var Nav = __webpack_require__(4193);
// EXTERNAL MODULE: ./components/Footer/Footer.js
var Footer = __webpack_require__(61);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 19 modules
var esm = __webpack_require__(8287);
// EXTERNAL MODULE: ./components/RefreshedFooter/RefreshedFooter.js
var RefreshedFooter = __webpack_require__(1216);
;// CONCATENATED MODULE: ./pages/blog/index.js













var __N_SSP = true;
function Blog(param) {
    let { posts , tags , footer , navigation  } = param;
    const [filters, setFilters] = (0,react.useState)([]);
    const filtersParams = filters.map((f)=>f.name);
    const [locale, setLocale] = (0,react.useState)("");
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        router.push({
            pathname: "/blog",
            query: {
                page: router.query.page ? router.query.page : 1,
                filters: filtersParams
            }
        });
    }, [
        filters
    ]);
    (0,react.useEffect)(()=>{
        const topLevelDomain = window.location.hostname.split(".").pop();
        setLocale(topLevelDomain === "es" ? "es" : "fr");
    }, []);
    (0,react.useEffect)(()=>{
        var _window_rudderanalytics;
        window === null || window === void 0 ? void 0 : (_window_rudderanalytics = window.rudderanalytics) === null || _window_rudderanalytics === void 0 ? void 0 : _window_rudderanalytics.page();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Bene Bono"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Bene Bono | Cestas Ecol\xf3gicas y Anti Desperdicio"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Bene Bono"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "benebono.".concat(locale)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://img.plasmic.app/img-optimizer/v1/img/c44d43862fdbf580d7139ef62c2c6ffa.png?q=75&f=webp"
                    }),
                     false && /*#__PURE__*/ 0
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                links: navigation.links
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "articles_container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: t("blog.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "articles",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "articles_section",
                                children: [
                                    posts.data.map((p, i)=>{
                                        var _p_attributes_preview_image_data_, _p_attributes, _p_attributes_preview_image, _p_attributes_preview_image_data__attributes;
                                        const tag = p.attributes.tags.data.map((t)=>t.attributes.name);
                                        if (i > 0 && i % 4 === 0) {
                                            var _p_attributes_preview_image_data_1, _p_attributes1, _p_attributes_preview_image1, _p_attributes_preview_image_data__attributes1;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostsRow, {
                                                imageUrl: (_p_attributes_preview_image_data_1 = (_p_attributes1 = p.attributes) === null || _p_attributes1 === void 0 ? void 0 : (_p_attributes_preview_image1 = _p_attributes1.preview_image) === null || _p_attributes_preview_image1 === void 0 ? void 0 : _p_attributes_preview_image1.data[0]) === null || _p_attributes_preview_image_data_1 === void 0 ? void 0 : (_p_attributes_preview_image_data__attributes1 = _p_attributes_preview_image_data_1.attributes) === null || _p_attributes_preview_image_data__attributes1 === void 0 ? void 0 : _p_attributes_preview_image_data__attributes1.url,
                                                title: p.attributes.title,
                                                author: p.attributes.author,
                                                date: dayjs_min_default()(p.attributes.publishedAt).format("DD MMMM YYYY"),
                                                tags: tag,
                                                description: p.attributes.description,
                                                slugUrl: p.attributes.slug
                                            }, i);
                                        }
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Posts, {
                                            imageUrl: (_p_attributes_preview_image_data_ = (_p_attributes = p.attributes) === null || _p_attributes === void 0 ? void 0 : (_p_attributes_preview_image = _p_attributes.preview_image) === null || _p_attributes_preview_image === void 0 ? void 0 : _p_attributes_preview_image.data[0]) === null || _p_attributes_preview_image_data_ === void 0 ? void 0 : (_p_attributes_preview_image_data__attributes = _p_attributes_preview_image_data_.attributes) === null || _p_attributes_preview_image_data__attributes === void 0 ? void 0 : _p_attributes_preview_image_data__attributes.url,
                                            title: p.attributes.title,
                                            author: p.attributes.author,
                                            date: dayjs_min_default()(p.attributes.publishedAt).format("DD MMMM YYYY"),
                                            tags: tag,
                                            description: p.attributes.description,
                                            slugUrl: p.attributes.slug
                                        }, i);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                        pageCount: posts.meta.pagination.pageCount,
                                        link: "/blog",
                                        filters: filtersParams
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tags_container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: t("blog.category")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: tags.map((t)=>{
                                            const isIncludes = filters.some((f)=>f.name.includes(t.attributes.name));
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                style: isIncludes ? {
                                                    backgroundColor: "#F06E36",
                                                    color: "#FFFFFF"
                                                } : {
                                                    backgroundColor: "rgba(240, 110, 54, 0.16)",
                                                    color: "#f06e36"
                                                },
                                                onClick: ()=>{
                                                    const name = t.attributes.name;
                                                    const isIncludes = filters.some((f)=>f.name.includes(name));
                                                    if (!isIncludes) setFilters((prevValue)=>[
                                                            ...prevValue,
                                                            {
                                                                name,
                                                                isActive: true
                                                            }
                                                        ]);
                                                    if (isIncludes) {
                                                        setFilters(filters.filter((f)=>f.name !== name));
                                                    }
                                                },
                                                children: [
                                                    t.attributes.name,
                                                    isIncludes ? /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* CloseIcon */.Tw, {}) : null
                                                ]
                                            }, t.id);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshedFooter/* default */.Z, {
                links: footer.links
            })
        ]
    });
}


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,193,774,888,179], function() { return __webpack_exec__(7286); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);